import "vue-loading-overlay/dist/css/index.css";
import { LoadingPlugin } from "vue-loading-overlay";
import type { App } from "vue";

// export default vue-loading-overlay
export default (app: App<Element>): void => {
  app.use(
    LoadingPlugin,
    {
      // props
      color: "#1976D2",
    },
    {
      // slots if any
    },
  );
};
